class Megamenu {
  constructor(e) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop"
    };

    this.menuSelectors = {
      subMenu: ".m-mega-menu"
    };

    this.activeDesktopMenuItem = null;
    this.sliders = {};
    this.open = false;
    this.container = e;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);

    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => ({
      header: item.closest("header"),
      item,
      ...queryDomNodes(this.menuSelectors, item),
      active: false
    }));

    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    this.domNodes.hamburgerButtons.addEventListener("click", (e) => {
      this.domNodes.hamburgerButtons.classList.contains("active")
        ? this.closeMenu()
        : this.openMenu();
      this.domNodes.hamburgerButtons.classList.toggle("active");
    });

    this.domNodes.backDrop.addEventListener("click", () => {
      this.closeMenu();
    });

    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }

  initDesktopMegaMenu() {
    [...this.menuData].forEach(({ item, subMenu }) => {
      if (subMenu) {
        const slider = subMenu.querySelector(".m-mega-product-list");
        if (slider) {
          if (window && window.__sfWindowLoaded) {
            this.initProductsBanner(slider);
          } else {
            window.addEventListener("load", () => {
              this.initProductsBanner(slider);
            });
          }
        }
      }
    });
  }

  closeDesktopSubmenu(index) {
    const { header } = this.menuData[index];
    if (header) header.classList.remove("show-menu");
  }

  initProductsBanner(element) {
    const header = element.closest("header");
    const menuItem = element.closest(".m-menu__item");
    const screenClass = header ? `.${header.dataset.screen}` : "";
    const id = element.dataset.id;
    const columnCount = document.querySelector(`.m-product-list-${id}`).dataset.column;

    const swiper = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columnCount },
        992: { slidesPerView: columnCount >= 2 ? 2 : columnCount }
      }
    });

    this.sliders[menuItem.dataset.index] = swiper;

    if (swiper) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => swiper.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => swiper.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((menuItem) => {
      const submenu = menuItem.querySelector(".m-megamenu-mobile");
      const backButton = menuItem.querySelector(".m-menu-mobile__back-button");

      if (submenu) {
        const toggleHandler = (e, el) => {
          e.preventDefault();
          const level = el.dataset.toggleSubmenu;
          const parent = e.target.parentNode;
          if (
            !e.target.classList.contains("m-menu-mobile__back-button") &&
            !parent.classList.contains("m-menu-mobile__back-button")
          ) {
            this.openSubMenu(submenu, level);
          }
        };

        addEventDelegate({
          context: menuItem,
          selector: "[data-toggle-submenu]",
          handler: toggleHandler
        });

        backButton &&
          backButton.addEventListener("click", (e) => {
            const level = e.target.dataset.level;
            this.closeSubMenu(submenu, level);
          });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  openMenu() {
    this.setMenuHeight();
    document.documentElement.classList.add("prevent-scroll");
    this.domNodes.menuDrawer.classList.add("open");
    this.domNodes.headerMobile.classList.add("header-drawer-open");
    this.open = true;
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons } = this.domNodes;

    setTimeout(() => {
      megaMenuMobile.forEach((el) => el.classList.remove("open"));
      if (menu) menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
      menuDrawer.classList.remove("open");
      document.documentElement.classList.remove("prevent-scroll");
      this.domNodes.headerMobile.classList.remove("header-drawer-open");
      hamburgerButtons.classList.remove("active");
    }, this.transitionDuration);

    this.open = false;
  }

  openSubMenu(menu, level) {
    const className = `m-submenu-open--level-${level}`;
    this.domNodes.menuDrawerContent.classList.add("open-submenu");
    this.domNodes.menu && this.domNodes.menu.classList.add("m-submenu-open", className);
    menu.classList.add("open");
  }

  closeSubMenu(menu, level) {
    const className = `m-submenu-open--level-${level}`;
    if (level === "1") this.domNodes.menu?.classList.remove("m-submenu-open");
    this.domNodes.menu?.classList.remove(className);
    menu.classList.remove("open");
    this.domNodes.menuDrawerContent.classList.remove("open-submenu");
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes;
    const bottom = headerMobile.getBoundingClientRect().bottom;
    const height = window.innerHeight - bottom;
    menuDrawer.style.setProperty("--menu-drawer-height", `${height}px`);
  }
}

class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container"
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active"
    };

    this.headerSticky = false;

    if (container) {
      this.container = container;
      this.domNodes = queryDomNodes(this.selectors, this.container);
      this.activeIndex = -1;
      this.lastActiveIndex = -1;
      this.visited = false;
      this.timeoutEnter = null;
      this.timeoutLeave = null;
      this.attachEvents();
    }
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((item, index) => {
      item.addEventListener("mouseenter", (e) => this.onMenuItemEnter(e, index));
      item.addEventListener("mouseleave", (e) => this.onMenuItemLeave(e, index));
    });
  };

  initDropdownSize = () => {
    if (this.container) {
      this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
      this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
    }
  };

  onMenuItemEnter = (e, index) => {
    const target = e.target;
    if (!target.classList.contains("m-menu__item--mega")) return;

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";

    this.reInitSlider(target);

    if (this.container && this.visited) {
      this.container.classList.remove(this.classes.slideReveal);
    } else {
      this.container.classList.add(this.classes.slideReveal);
    }

    this.visited = true;

    if (this.lastActiveIndex >= 0 && this.activeIndex >= 0) {
      if (this.lastActiveIndex < this.activeIndex) {
        this.container.classList.add(this.classes.slideFromRight);
      } else {
        this.container.classList.remove(this.classes.slideFromRight);
      }
    }

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex === Number(target.dataset.index)) {
          this.container.classList.add(this.classes.active);
          target.closest(".m-menu__item").classList.add("m-menu__item--active");
        }
      }, 120);
    });
  };

  onMenuItemLeave = (e, index) => {
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    e.target.closest(".m-menu__item").classList.remove("m-menu__item--active");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex < 0) {
        this.visited = false;
        this.resetMegaMenu(e.target);
      }
    }, 80);
  };

  reInitSlider = (element) => {
    if (!element.querySelector(this.selectors.swiper)) return;
    const index = element.dataset.index;
    const swiper = MinimogTheme?.headerSliders[index];
    swiper?.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;
    clearTimeout(this.timeoutEnter);
    this.container?.classList.remove(
      this.classes.active,
      this.classes.slideFromRight,
      this.classes.slideReveal,
      "sf-header--bg-black",
      "sf-header--bg-white"
    );
  };

  windowWidth = () => window.innerWidth;
  windowHeight = () => window.innerHeight;

  destroy = () => {
    this.domNodes.menuItems.forEach((item, index) => {
      item.removeEventListener("mouseenter", (e) => this.onMenuItemEnter(e, index));
      item.removeEventListener("mouseleave", (e) => this.onMenuItemLeave(e, index));
    });
  };
}
